import styled from '@emotion/styled'

const StyledContent = styled.input`
  outline: none;
  appearance: none;
  -webkit-appearance: none;
  display: inline-block;
  -moz-appearance: none;
  position: relative;
  cursor: pointer;
  width: 48px;
  height: 24px;
  zoom: ${(props) => {
    const { size } = props
    if (size === 'lg') {
      return '133%'
    }
    if (size === 'sm') {
      return '75%'
    }
    return '100%'
  }};
  border: 1px solid #dbdfea;
  box-sizing: border-box;
  background: #fff;
  border-radius: 24px;
  transition: border-color 0.3s, background-color 0.3s;
  ::after {
    content: '';
    display: inline-block;
    width: 16px;
    height: 16px;
    border-radius: 50%;
    background: #dbdfea;
    box-shadow: 0, 0, 2px, #999;
    transition: 0.4s;
    top: 3px;
    position: absolute;
    left: 5px;
  }
  :checked {
    background-color: ${(props) => {
      const { backgroundColor } = props
      return backgroundColor
    }};
  }
  :disabled {
    opacity: 0.5;
  }

  /* 当input[type=checkbox]被选中时：伪元素显示下面样式 位置发生变化 */
  :checked::after {
    content: '';
    position: absolute;
    left: 57%;
    top: 3px;
  }
`
export default StyledContent
